import React from "react";

import PageHeading from "2g-page-heading";

import FixniNarokyNasledujiciWidget from "b2b/components/fixni-naroky-nasledujici/FixniNarokyNasledujiciWidget";
import FixniNarokyNasledujiciCount from "b2b/components/fixni-naroky-nasledujici/FixniNarokyNasledujiciCount";
import FixniNarokyNasledujiciItem from "b2b/components/fixni-naroky-nasledujici/FixniNarokyNasledujiciItem";

export function FixniNarokyNasledujiciExample() {
  return (
    <div>
      <div data-testid="open-fixni">
        <FixniNarokyNasledujiciWidget ico={1} />
      </div>

      <div data-testid="item-count-available">
        <PageHeading>FixniNarokyNasledujiciCount</PageHeading>
        <div
          style={{
            display: "flex",
            backgroundColor: "white",
            padding: "20px",
            gap: "20px"
          }}
        >
          <FixniNarokyNasledujiciCount title="VZO" zadane={2} povolene={5} />
          <FixniNarokyNasledujiciCount title="MZO" zadane={5} povolene={5} />
        </div>
      </div>

      <div data-testid="item">
        <PageHeading>FixniNarokyNasledujiciItem</PageHeading>
        <FixniNarokyNasledujiciItem
          smlouva={{
            cislo: "123456",
            platnostOd: 1614556800,
            platnostDo: 1646092800
          }}
          vzo={{ zadane: 2, povolene: 5 }}
          mzo={{ zadane: 5, povolene: 5 }}
        />
      </div>

      <div data-testid="item-loading">
        <PageHeading>FixniNarokyNasledujiciItem loading</PageHeading>
        <FixniNarokyNasledujiciItem
          smlouva={{
            cislo: "123456",
            platnostOd: 1614556800,
            platnostDo: 1646092800
          }}
          vzo={{ zadane: 2, povolene: 5 }}
          mzo={{ zadane: 5, povolene: 5 }}
          loading
        />
      </div>
    </div>
  );
}

FixniNarokyNasledujiciExample.propTypes = {};

export default React.memo(FixniNarokyNasledujiciExample);
